import { render, staticRenderFns } from "./growthModel.vue?vue&type=template&id=98bdf7ce&scoped=true"
import script from "./growthModel.vue?vue&type=script&lang=js"
export * from "./growthModel.vue?vue&type=script&lang=js"
import style0 from "./growthModel.vue?vue&type=style&index=0&id=98bdf7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bdf7ce",
  null
  
)

export default component.exports